import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { t } from 'utils/translates';

import ListItemLink from 'components/Common/ListItemLink/ListItemLink';
import StatusesDescTable from 'components/Rating/StatusesDescTable';
import RatingPointHistoryTable from 'components/Rating/RatingPointHistoryTable';

import UserDaysStat from 'components/UserDaysStat/UserDaysStatTables/UserDaysStatTable1/index';
import UserFlowFundsHistoryTable from 'components/UserFlowFunds/UserFlowFundsHistoryTable';
import PopUpLink from 'components/Common/GlobalPopUps/PopUpLink';

import MyCountsStat from './MyCountsStat';

const myRatingTab1Name = 'all-statuses';
const myRatingTab2Name = 'points-history';

const myStatTab1Name = 'user-days-stat';
const myStatTab2Name = 'flow-funds-history';

class MyRatingAndStat extends Component {
  constructor(props) {
    super(props);
    this.inputsRefs = {
      rating: React.createRef()
    };
  }

  componentDidMount() {
    this.scrollToRatingBlock();
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.hash !== prevProps.location.hash) {
      this.scrollToRatingBlock();
    }
  }

  scrollToRatingBlock = () => {
    if (this.props.location.hash === '#ratingBlock') {
      this.inputsRefs.rating.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  render() {
    const myRatingTabContent = () => {
      if (this.props.match.params.myRatingTabName === myRatingTab1Name) {
        return <StatusesDescTable />;
      } else if (this.props.match.params.myRatingTabName === myRatingTab2Name) {
        return (
          <RatingPointHistoryTable
            setGroupQueryParamsAndUpdateHistory={
              this.props.setGroupQueryParamsAndUpdateHistory
            }
          />
        );
      }
      return null;
    };

    const myStatTabContent = () => {
      if (this.props.match.params.myStatTabName === myStatTab1Name) {
        return (
          <UserDaysStat
            setGroupQueryParamsAndUpdateHistory={
              this.props.setGroupQueryParamsAndUpdateHistory
            }
          />
        );
      } else if (this.props.match.params.myStatTabName === myStatTab2Name) {
        return (
          <UserFlowFundsHistoryTable
            setGroupQueryParamsAndUpdateHistory={
              this.props.setGroupQueryParamsAndUpdateHistory
            }
          />
        );
      }
      return null;
    };

    return (
      <React.Fragment>
        <MyCountsStat />
        <div
          className="panel panel-default panel-heading_padding-large"
          id="rating"
          ref={this.inputsRefs.rating}
        >
          <div className="panel-heading">
            <PopUpLink
              className="text-muted pull-right"
              hashName="userPointsTypes"
            >
              <i className="fa fa-exclamation-circle" />{' '}
              {t('Как изменить рейтинг')}
            </PopUpLink>
            <h1 className="panel-title">
              <i className="fa fa-star" /> {t('Мой рейтинг')}
            </h1>
          </div>
          <div className="panel-bar">
            <ul className="nav nav-tabs nav-tabs-lg">
              <ListItemLink
                to={{
                  pathname: `/main/my-rating-and-stat/${myRatingTab1Name}/${this.props.match.params.myStatTabName}`,
                  search: this.props.searchString
                }}
              >
                {t('Статус')}
              </ListItemLink>
              <ListItemLink
                to={{
                  pathname: `/main/my-rating-and-stat/${myRatingTab2Name}/${this.props.match.params.myStatTabName}`,
                  search: this.props.searchString
                }}
              >
                {t('История')}
              </ListItemLink>
            </ul>
          </div>
          <div className="panel-body">
            <div className="tab-content">{myRatingTabContent()}</div>
          </div>
        </div>
        <div
          className="panel panel-default panel-heading_padding-large"
          id="myStatistics"
        >
          <div className="panel-heading">
            <h2 className="panel-title">
              <i className="fa fa-bar-chart" /> {t('Моя статистика')}
            </h2>
          </div>
          <div className="panel-bar">
            <ul className="nav nav-tabs nav-tabs-lg">
              <ListItemLink
                to={{
                  pathname: `/main/my-rating-and-stat/${this.props.match.params.myRatingTabName}/${myStatTab1Name}`,
                  search: this.props.searchString
                }}
              >
                {t('Статистика')}
              </ListItemLink>
              <ListItemLink
                to={{
                  pathname: `/main/my-rating-and-stat/${this.props.match.params.myRatingTabName}/${myStatTab2Name}`,
                  search: this.props.searchString
                }}
              >
                {t('История')}
              </ListItemLink>
              <ListItemLink to={`/referral-program/my-stat`}>
                <i className="fa fa-external-link-square" />{' '}
                {t('Статистика партнерской прог.')}
              </ListItemLink>
            </ul>
          </div>
          <div className="panel-body">
            <div className="tab-content">{myStatTabContent()}</div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

MyRatingAndStat.contextTypes = {
  router: PropTypes.shape()
};

MyRatingAndStat.propTypes = {
  // IN
  setGroupQueryParamsAndUpdateHistory: PropTypes.func.isRequired,
  searchString: PropTypes.string.isRequired,

  match: PropTypes.shape({
    params: PropTypes.shape({
      myRatingTabName: PropTypes.oneOf([myRatingTab1Name, myRatingTab2Name])
        .string,
      myStatTabName: PropTypes.oneOf([myStatTab1Name, myStatTab2Name]).string
    }).isRequired
  }).isRequired,

  location: PropTypes.shape({
    hash: PropTypes.string.isRequired,
    search: PropTypes.string.isRequired,
    pathname: PropTypes.string.isRequired
  }).isRequired
};

export default withRouter(MyRatingAndStat);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Main/MyRatingAndStat/MyRatingAndStat.js